
<template>
  <van-popup v-model="modelShow" position="bottom">
    <van-picker
      value-key="name"
      @cancel="modelShow = false"
      @change="bindMultiPickerColumnChange"
      @confirm="bindMultiPickerChange"
      show-toolbar
      title="请选择省市区"
      :columns="multiArray"
    />
  </van-popup>
</template>

<script>
import { getFindAreaList } from "../../common/api/index";
import { Picker, Popup } from "vant";
export default {
  name: "pi-select-city",
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  props: {
    value: {
      default: ()=>{
        return {}
      },
      type: Object,
    },
  },
  watch : {
    'value': (data)=>{
      if(data){
        this.init(data);
      }
    }
  },
  data() {
    return {
      modelShow: false,
      multiArray: [
        // 第一列
        {
          values: [
            // { name: "广东省", value: 1 },
            // { name: "广西省", value: 2 },
          ],
          defaultIndex: 1,
        },
        // 第二列
        {
          values: [
           
          ],
          defaultIndex: 1,
        },
        // 第三列
        {
          values: [
           
          ],
          defaultIndex: 1,
        },
      ],
      isFrist: false,
    };
  },
  methods: {
    async getFindAreaList(parentId, regionLevel, cityDataId) {
      let ret = await getFindAreaList({
        parentId: parentId,
        regionLevel: regionLevel,
      });
      if (ret.status === 0) {
        let multiArray = this.multiArray;
        if (regionLevel == 1) {
          multiArray[0].values = ret.data;

          let value = ret.data[0].pkid;
          let defaultIndex = 0;

          if (cityDataId && cityDataId.provinceId) {
            let index = ret.data.findIndex(
              (item) => item.pkid == cityDataId.provinceId
            );
            if (index > 0) {
              defaultIndex = index;
              value = cityDataId.provinceId;
            }
          }
          multiArray[0].defaultIndex = defaultIndex;
          this.getFindAreaList(value, 2, cityDataId);
        } else if (regionLevel == 2) {
          multiArray[1].values = ret.data;

          let value = ret.data[0].pkid;
          let defaultIndex = 0;

          if (cityDataId && cityDataId.cityId) {
            let index = ret.data.findIndex(
              (item) => item.pkid == cityDataId.cityId
            );
            if (index > 0) {
              defaultIndex = index;
              value = cityDataId.cityId;
            }
          }

          multiArray[1].defaultIndex = defaultIndex;
          this.getFindAreaList(value, 3, cityDataId);
        } else {
          multiArray[2].values = ret.data;
          let defaultIndex = 0;

          if (cityDataId && cityDataId.regionId) {
            let index = ret.data.findIndex(
              (item) => item.pkid == cityDataId.regionId
            );
            if (index > 0) {
              defaultIndex = index;
            }
          }
          multiArray[2].defaultIndex = defaultIndex;
        }
        this.multiArray = multiArray;
      }
    },
    bindMultiPickerColumnChange(picker, value, index) {
      let parentId = value[index].pkid;
      if (index == 0) {
        this.getFindAreaList(parentId, 2);
      } else if (index == 1) {
        this.getFindAreaList(parentId, 3);
      }
    },

    bindMultiPickerChange(val) {
      this.regionname = val[0].name + val[1].name + val[2].name;
      this.modelShow = false;
      this.$emit('change',{data:val,regionname:this.regionname})
    },
    init(data) {
      if (data) {
        let cityDataId = {
          provinceId: data.provinceId,
          cityId: data.cityId,
          regionId: data.regionId,
        };
        this.getFindAreaList(null, 1, cityDataId);
      } else {
        this.getFindAreaList(null, 1);
      }
    },
    open(){
      this.modelShow = true;
      if(!this.isFrist){
        this.isFrist = true;
        let data = this.value.provinceId ? this.value: null;
        this.init(data);
      }
    }
  },
};
</script>

<style lang="less">

</style>
